// extracted by mini-css-extract-plugin
module.exports = {"loader":"CompanyList_loader__2iGHH"};